import axios from "axios";

const errorCodes = [401, 403];

export const apiRequest = async (method, url, data = null) => {
    const config = {
        method: method,
        url: `${process.env.REACT_APP_BASE_URL}${url}`,
        headers: {
            'Authorization': `Bearer ${localStorage.getItem('token') || localStorage.getItem('temp-token')}`,
            'Accept': 'application/json'
        },
        data: data
    };

    if (method.toLowerCase() === 'delete') {
        delete config.data;
    } else if (data) {
        config.data = data;
    }

    try {
        const response = await axios(config);
        return response;
    } catch (error) {
        if (errorCodes?.includes(error?.response?.status) && (localStorage.getItem('token') || localStorage.getItem('temp-token'))) {
            localStorage.clear();
            window.location.href = '/';
        }
        throw error;
    }
};